import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import { FilledButton, Modal, ModalFooter } from '@/user/components/common';
import { computed } from 'vue';
import { I18nInfo } from '@/user/models';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AlertModal',
    props: {
        modelValue: { type: Boolean },
        message: {},
        onConfirm: { type: Function },
        verticalAlign: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const t_common = new I18nInfo('common');
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        function handleConfirm() {
            props.onConfirm();
            isOpen.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                size: "small",
                title: _unref(t_common).translate('modal.noti'),
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                "vertical-align": props.verticalAlign || 'center'
            }, {
                content: _withCtx(() => [
                    _createElementVNode("p", { innerHTML: __props.message }, null, 8, _hoisted_1)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: handleConfirm
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.confirm')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["title", "modelValue", "vertical-align"]));
        };
    }
});
